import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { APIS } from "../../../utils/APIS";
import { GET, POST, PUT, DELETE } from "../../../utils/Methods";
import { IDS } from "../../../utils/IDS";

export const GetAll = createAsyncThunk(
  "certificate-generation/certificate-management/get-all",
  async (filter, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${
          APIS.CerficateManagement.CerficateGenerate
        }?invoice_no=${filter?.InvoiceNo ||
          ""}&customer_name=${filter?.CustomerName ||
          ""}&customer_id=${filter?.CustomerID ||
          ""}&start_date=${filter?.startDate ||
          ""}&end_date=${filter?.endDate || ""}&id=${filter?.id || ""}&page=${filter?.page ||
          IDS.PAGE}&per_page=${filter?.per_page || IDS.PERPAGE}
          `,
      );

      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const GetSingle = createAsyncThunk(
  "certificate-generation/certificate-management/get",
  async (id, { rejectWithValue }) => {
    try {
      const res = await GET(
        `${APIS.CerficateManagement.CerficateGenerate}/${id}`,
      );
      return res;
    } catch (error) {
      return rejectWithValue(error.message);
    }
  },
);

export const CreateCustomer = createAsyncThunk(
  "certificate-generation/certificate-management/createcustomer",

  async (data, { rejectWithValue }) => {
    console.log("this is called");
    try {
      const res = await POST(APIS.CerficateManagement.CerficateGenerate, data);

      console.log("resresresres", res);
      return res;
    } catch (error) {
      console.log(error, "error");

      return rejectWithValue(error);
    }
  },
);

export const CertificateInvoiceGenerate = createAsyncThunk(
  "certificate-generation/invoice-generate",

  async (data, { rejectWithValue }) => {
    try {
      const res = await POST(`${APIS.CerficateManagement.CerficateGenerate}/certificate-download`, data);

      return res;
    } catch (error) {
      console.log(error, "error");

      return rejectWithValue(error);
    }
  },
);

export const Slice = createSlice({
  name: "certificateManagement",
  initialState: {
    data: [],

    current_page: IDS.PAGE,
    total_pages: IDS.TOTALPAGES,
    per_page: IDS.PERPAGE,
    total: IDS.TOTAL,

    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      // Handling all actions for GetSingle, Create, Update, Delete
      .addCase(GetAll.pending, (state) => {
        console.log(state, "pending");
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetAll.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        console.log(action, "fulfilled");

        state.data = action.payload?.data || {};
        // state.current_page = action.payload?.data?.current_page || IDS.PAGE;
        // state.total_pages = action.payload?.data?.total_pages || IDS.TOTALPAGES;
        // state.per_page = action.payload?.data?.per_page || IDS.PERPAGE;
        // state.total = action.payload?.data?.total || IDS.TOTAL;
      })
      .addCase(GetAll.rejected, (state, action) => {
        console.log(action, "rejected");
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(GetSingle.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(GetSingle.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
      })
      .addCase(GetSingle.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(CreateCustomer.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(CreateCustomer.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(CreateCustomer.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      })

      .addCase(CertificateInvoiceGenerate.pending, (state) => {
        state.status = IDS.SLICESTATUS.Loading;
      })
      .addCase(CertificateInvoiceGenerate.fulfilled, (state, action) => {
        state.status = IDS.SLICESTATUS.Succeeded;
        // state.data = action.payload;
        state.data.unshift(action.payload.data);
      })
      .addCase(CertificateInvoiceGenerate.rejected, (state, action) => {
        state.status = IDS.SLICESTATUS.Failed;
        state.error = action.payload;
      });
  },
});

// Export actions (if needed in components)
export const {} = Slice.actions;

export default Slice.reducer;
